const initialState = {
  claimLocation: null,
  stepCompleted: false,
}

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case 'RESET_CLAIMS': {
      return initialState
    }

    case 'SET_LOCATION': {
      return {
        ...state,
        claimLocation: action.payload.claimLocation,
        stepCompleted: true,
      }
    }

    default: {
      return state
    }
  }
}
